
import 'jquery';
import $ from 'jquery';
import Vue from 'vue';
import { FormWizard, TabContent } from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import { Component, Watch } from 'vue-property-decorator';
import VueSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import Toasted from 'vue-toasted';
import DatePicker from 'vuejs-datepicker';
import { handleError, initClient } from '../../api';
import { blobDownload, WindowType } from '../../util';
import { CellClient, CellList, Duty, DutyClient, DutyDate, IDuty, ListDutyTriggerItem, ListItem, ListItemCell, VMDutyCreate } from '../backend/backendapi';
import CreateActivityModal from './createActivityModal/createActivityModal.controller';
import CreateActivityWithDutyAndCellModal from './createActivityWithDutyAndCellModal/createActivityWithDutyAndCellModal.controller';
import EditModal from './editmodal/editmodal.controller';
import { getVMDutyCreate } from './dutyui.util';
import DropZone from '../dropzone/DropZone';

declare var window: WindowType;

Vue.use(Toasted, { duration: 2000 });

@Component({
  name: 'DutyuiComponent',
  components: {
    DatePicker,
    DropZone,
    FormWizard,
    TabContent,
    VueSelect,
    VueGoodTable,
    AdvancedNotificationModal: require('./advancedNotificationModal/advancedNotificationModal.vue.html').default,
    CreateActivityModal: require('./createActivityModal/createActivityModal.vue.html').default,
    CreateActivityWithDutyAndCellModal: require('./createActivityWithDutyAndCellModal/createActivityWithDutyAndCellModal.vue.html').default,
    DisabledModal: require('./disabledModal/disabledModal.vue.html').default,
    DueTimespanModal: require('./dueTimespanModal/dueTimespanModal.vue.html').default,
    EditModal: require('./editmodal/editmodal.vue.html').default,
    ImageViewer: require('../imageviewer/imageviewer.vue.html').default,
  },
})
export default class DutyuiComponent extends Vue {
  private readonly cellApi: CellClient = initClient(CellClient);
  private readonly dutyApi: DutyClient = initClient(DutyClient);

  private readonly duties: Duty[] = [];
  private readonly users: ListItem[] = [];
  private readonly cells: CellList[] = [];
  private readonly triggers: ListDutyTriggerItem[] = [];

  private readonly selectedIndex: Duty[] = [];
  // private readonly dutyCreateFiles: Media2[] = [];
  private dutyCreate: VMDutyCreate | null = null;

  get columnsConfig() {
    return [
      {
        label: 'Name',
        field: 'title',
      },
      {
        label: this.$i18n.t('txtDutyCell').toString(),
        field: 'cell',
      },
      {
        label: 'Ident',
        field: 'identString',
      },
      {
        label: this.$i18n.t('txtLabels').toString(),
        field: 'label',
      },
      {
        label: 'D',
        field: (d: Duty) => d.isDisabled ? 'D' : '',
      },
    ];
  }

  get isMaintenance(): boolean {
    return window.application.check2.isMaintenanceMode;
  };

  get isPrintQr(): boolean {
    return window.application.permissions.duty.printqr;
  };

  get isUpload(): boolean {
    return window.application.permissions.duty.isDutyUpload;
  };

  get selectConfig(): object {
    return {
      enabled: true,
      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
      selectionText: this.getSelectionTextStr(),
      clearSelectionText: this.getClearStr(),
      disableSelectInfo: false, // disable the select info panel on top
      selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
    };
  }

  async mounted(): Promise<void> {
    await this.fetchcells();
    await this.fetchduties();
    this.handleModalOpenTriggerByUrl();
  }

  private async fetchcells(): Promise<void> {
    const data = await this.cellApi.getCellsAndTreeData();
    this.cells.splice(0);
    this.cells.push(...data);
  }

  private async fetchduties(): Promise<void> {
    const data = await this.dutyApi.getDutiesData();
    this.duties.splice(0);
    this.duties.push(...data.duties);
    this.users.splice(0);
    this.users.push(...data.users);
    this.triggers.splice(0);
    this.triggers.push(...data.triggers);
  }

  private handleModalOpenTriggerByUrl(): void {
    let url = new URL(window.location.href);
    if (url.searchParams.has('duty')) {
      if (url.searchParams.has('action')) {
        //create new duty from params
        if (url.searchParams.get('action') === 'new') {
          this.onAdd(dutyCreate => {
            if (url.searchParams.has('cells')) {
              dutyCreate.cells = [new ListItemCell({ id: parseInt(url.searchParams.get('cells')!) })];
            }
          });
        }
      } else {
        //open duty by id
        let id = parseInt(url.searchParams.get('duty')!);
        let duty = this.duties.find(e => e.dutyId === id);
        if (duty) {
          this.selectedIndex.splice(0);
          this.selectedIndex.push(duty);
          this.editSelected();
  
          //remove the search param from url to a reload of this component does not trigger a the modal again
          url.searchParams.delete('duty');
          window.history.pushState(undefined, '', url);
        }
      }
    }
  }

  private clearSelection(): void {
    this.selectedIndex.splice(0);
  }

  // Fetches the data after 1 second and also clears the inputs etc.s
  fetchAndClear(): Promise<void> {
    // Create a new Promise and resolve after 1 seconds
    var myTimerPromise = new Promise((resolve, reject) => {
      setTimeout(resolve, 500);  // "resolve" is already a function, no need for another anonymous function here
    });

    // Fetch data now, within Promise.all()
    return Promise.all([myTimerPromise]).then(() => {
      this.fetchcells();
      this.fetchduties();
      this.clearSelection();
      this.dutyCreate = null;
      // this.dutyCreateFiles.splice(0);
    });
  }

  private async onComplete(): Promise<void> {
    if (!this.dutyCreate) {
      return;
    }

    try {
      if (!this.dutyCreate.duty.dutyId) {
        await this.dutyApi.postDutyData(this.dutyCreate);
      } else {
        await this.dutyApi.updateDuty(this.dutyCreate);
      }

      this.fetchAndClear();
      (this.$refs.editmodal as EditModal).dismiss();
      this.$toasted.info(this.$t('txtDone').toString()).goAway(2000);
    } catch (e) {
      handleError(this.$toasted, this.$i18n, e);
    }
  }

  private onCreateActivity(): void {
    if (this.selectedIndex.length == 1) {
      (this.$refs.createActivityModal as CreateActivityModal).openModal();
    } else if (this.selectedIndex.length == 0) {
      (this.$refs.createActivityWithDutyAndCellModal as CreateActivityWithDutyAndCellModal).openModal();
    }
  }

  private selectionChanged(params: { selectedRows: Duty[] }): void {
    this.selectedIndex.splice(0);
    this.selectedIndex.push(...params.selectedRows);
  }

  //event handler
  private onAdd(init?: ((dutyCreate: VMDutyCreate) => void) | undefined): void {
    let firstdate = DutyDate.fromJS({
      start: new Date(),
      datePattern: 0,
      repeatInterval: undefined,
      repeatYear: undefined,
      repeatMonth: undefined,
      repeatDay: undefined,
      repeatWeek: undefined,
      repeatWeekday: undefined,
      repeatWeekOfMonth: undefined,
      repeatHour: undefined,
    });
    let duty = Duty.fromJS({
      datePattern: 0, firstDate: firstdate, skipNextAutoTrigger: false, title: '', files: [], isDisabled: false, advancedReminderHours: 0, dueSeconds: 0,
      preventAutoTriggeredActivityDuplicates: false, cbmAnonymousEnabled: false, cbmInsertIntoWorkflowEnabled: false, cbmAutoCloseActivity: false,
      ratePerHour: 0, cbmMailAnswerEnabled: false
    } as IDuty);
    let triggers = this.triggers.map(e => new ListDutyTriggerItem(e));
    this.dutyCreate = new VMDutyCreate({ duty: duty, strJsonTodo: '[]', idTodoList: 0, users: [], cells: [], triggers: triggers, triggerSelected: 0 });
    // this.dutyCreateFiles.splice(0);
    if (init) {
      init(this.dutyCreate);
    }

    $('.media-list list-unstyled').remove();
    this.$nextTick(() => (this.$refs.editmodal as EditModal).open());
  }

  private async editSelected(): Promise<void> {
    if (this.selectedIndex.length !== 1 || this.selectedIndex[0].dutyId === undefined) {
      return;
    }
    console.log(this.selectedIndex[0].dutyId);

    this.dutyCreate = await getVMDutyCreate(this.selectedIndex[0].dutyId!);

    $('.media-list list-unstyled').remove();//TODO this is really bad system design
    this.$nextTick(() => (this.$refs.editmodal as EditModal).open());
  }

  private async deleteSelected(): Promise<void> {
    if (this.selectedIndex.length === 0) {
      return;
    }
    await this.dutyApi.deleteConfirmed(this.selectedIndex);
    await this.fetchAndClear();
  }

  private onCopyDuty(): void {
    if (this.selectedIndex.length !== 1) {
      return;
    }
    this.dutyApi.cloneDuty(this.selectedIndex[0].dutyId!)
        .then(e => this.$toasted.info(this.$t('txtDone').toString()).goAway(2000))
        .catch(e => handleError(this.$toasted, this.$i18n, e));
    this.fetchAndClear();
  }

  private async generateQR(): Promise<void> {
    if (this.selectedIndex.length <= 0) {
      return;
    }

    console.log('print qr for duties' + JSON.stringify(this.selectedIndex));
    await this.dutyApi.generateQRCodes(2, this.selectedIndex)
        .then(response => response.data)
        .then(blob => blobDownload(blob, 'qrcode-duty.pdf'));
  }

  private exportDuty(): void {
    this.dutyApi.export()
        .then(response => blobDownload(response.data, response.fileName!));
  }

  private get url(): string {
    return window.application.baseUrl + 'api/duty/import';
  }

  //getter
  private getClearStr(): string {
    return this.$i18n.t('comClear').toString();
  }

  private getSelectionTextStr(): string {
    return this.$i18n.t('comSelectionCnt').toString();
  }

  private get techAreaOptions(): string[] {
    return [...this.duties
        .map(e => e.techArea!)
        .filter((v, i, a) => v && a.indexOf(v) === i),//nonnull && unique
      ''];
  }

  //watches
  //dots menu won't close on click of a checkbox in vue-good-table so we close the dots menu when the selectedIndex is changed
  @Watch('selectedIndex')
  private watchSelectedIndexToCloseDotsMenu() {
    const dotsMenu = this.$refs.dotsMenu as HTMLElement;
    $(dotsMenu).dropdown('hide');
  }
}
